import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import theme from '@monorepo/shared/src/themes/defaultTheme';
import makeStyles from '@mui/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { remCalc } from '@monorepo/shared/src/util/style-util';

const t = (key: string, options?) => translate('common', key, options);

const InfoPopover: React.FC = ({ children }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLSpanElement) | null>(null);
  const open = Boolean(anchorEl);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLSpanElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        onClick={handlePopoverOpen}
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        displayPrint="none"
        className={classes.root}
      >
        <FontAwesomeIcon
          icon={faInfoCircle}
          color={theme.palette.primary.main}
          style={{ fontSize: remCalc(16) }}
        />
      </Box>
      <Popover
        id="mouse-over-popover"
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        onMouseLeave={handlePopoverClose}
        disableRestoreFocus
      >
        <Box p={4}>{children}</Box>
        <Divider />
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button
            aria-label={t('dismiss')}
            variant="contained"
            color="primary"
            size="small"
            disableElevation
            onClick={handlePopoverClose}
          >
            {t('dismiss')}
          </Button>
        </Box>
      </Popover>
    </>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    cursor: 'pointer',
    padding: remCalc(4),
  },
  paper: {
    maxWidth: 300,
    overflow: 'visible',
    '&:before': {
      content: '""',
      display: 'block',
      width: '0',
      height: '0',
      position: 'absolute',
      borderLeft: '12px solid transparent',
      borderRight: '12px solid transparent',
      borderBottom: '12px solid #fff',
      filter: 'drop-shadow(-1px -1px 1px rgba(0,0,0,.2))',
      left: 'calc(50% - 12px)',
      top: '-8px',
    },
  },
}));

export default InfoPopover;
